import { Button, DatePicker, Input, Radio, Select, Table } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { cancelManageColumns, filterCategoryOptions, filterStatusOptions, IProgramBookingForCancelManage, TSearchCategory, useGetAllProgramBookingForCancelManage } from "./model";
import { EProgramBookingStatus, textToProgramBookingStatusMap } from "../../wellnessProgram/program/booking/model";

const CancelManage = () => {
    const today: [Dayjs, Dayjs] = [dayjs().startOf('d'), dayjs().endOf('d')];
    const oneWeek: [Dayjs, Dayjs] = [dayjs().startOf('d').add(-7, 'd'), dayjs().endOf('d')];
    const oneMonth: [Dayjs, Dayjs] = [dayjs().startOf('d').add(-30, 'd'), dayjs().endOf('d')];
    const [fillteredDataList, setFillteredDataList] = useState<any[]>([]);
    const [filterDateList, setFilterDateList] = useState<[Dayjs, Dayjs]>(oneWeek)
    const [filterStatus, setFilterStatus] = useState<string[]>(['all']);
    const [filterSearch, setFilterSearch] = useState<string>('')
    const [filterCategory, setFilterCategory] = useState<TSearchCategory>('memberName')
    const { data = [], isFetching } = useGetAllProgramBookingForCancelManage<IProgramBookingForCancelManage[]>([EProgramBookingStatus.COMPLETE, EProgramBookingStatus.REQUEST_CANCEL, EProgramBookingStatus.CANCEL, EProgramBookingStatus.REFUND]);
    const onFilterDataList = () => {
        const fillterdData = data.filter(q =>
            (filterDateList[0].isBefore(dayjs(q.requestCancelDateTime)) && filterDateList[1].isAfter(dayjs(q.requestCancelDateTime)))
            && (filterStatus.includes('all') || filterStatus.includes(textToProgramBookingStatusMap[q.status] ?? q.status))
            && (filterSearch === '' || (filterCategory === 'memberName')
                ? q.memberName.includes(filterSearch)
                : filterCategory === 'memberMobile'
                    ? q.memberMobile.includes(filterSearch)
                    : filterCategory === 'programTitle'
                    && q.programTitle.includes(filterSearch))
        )
        setFillteredDataList(fillterdData.sort((a, b) => dayjs(b.requestCancelDateTime).diff(dayjs(a.requestCancelDateTime))))
    }

    useEffect(() => {
        if (isFetching) return;
        onFilterDataList()
    }, [isFetching])

    useEffect(() => {
        onFilterDataList()
    }, [filterDateList, filterStatus, filterSearch, filterCategory])

    return <>
        <div style={{ paddingBottom: '56px' }}>
            <div style={{ fontWeight: 700, fontSize: '18px', marginBottom: '17px' }}>
                취소 요청 관리
            </div>

            <div style={{ width: '50%', display: 'flex', alignItems: 'center', paddingBottom: '24px' }}>
                <div style={{ flex: 1, fontWeight: 400, fontSize: '14px', lineHeight: '22px' }}>
                    상태
                </div>
                <Select value={filterStatus} onChange={q => setFilterStatus(q)} style={{ flex: 3 }} mode='multiple' options={filterStatusOptions} />
            </div>

            <div style={{ width: '50%', display: 'flex', alignItems: 'center', paddingBottom: '24px' }}>
                <div style={{ height: '32px', flex: 1, fontWeight: 400, fontSize: '14px', lineHeight: '32px' }}>
                    취소 요청일
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', flex: 3 }}>
                    <Radio.Group defaultValue={fillteredDataList === oneWeek ? 'oneWeek' : fillteredDataList === today ? 'today' : fillteredDataList === oneMonth ? 'oneMonth' : 'oneWeek'} optionType='button' onChange={q => { setFilterDateList(q.target.value === 'today' ? today : q.target.value === 'oneWeek' ? oneWeek : q.target.value === 'oneMonth' ? oneMonth : today) }}>
                        <Radio value={'today'}>
                            오늘
                        </Radio>
                        <Radio value={'oneWeek'}>
                            7일
                        </Radio>
                        <Radio value={'oneMonth'}>
                            1개월
                        </Radio>
                    </Radio.Group>
                    <DatePicker.RangePicker
                        allowClear={false}
                        value={filterDateList}
                        onChange={dates => setFilterDateList(dates && dates[0] && dates[1] ? [dates[0], dates[1]] : oneWeek)}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', paddingBottom: '24px' }}>
                <div style={{ width: '50%', display: 'flex', alignItems: 'center', marginRight: '25px' }}>
                    <div style={{ flex: 1, fontWeight: 400, fontSize: '14px', lineHeight: '22px' }}>
                        검색
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '16px', flex: 3 }}>
                        <Select style={{ minWidth: '100px' }} value={filterCategory} onChange={q => setFilterCategory(q)} options={filterCategoryOptions} />
                        <Input style={{ width: '100%' }} placeholder="검색" value={filterSearch} onChange={q => setFilterSearch(q.target.value)} onPressEnter={onFilterDataList} />
                    </div>
                </div>
                <Button type='primary' onClick={onFilterDataList}>검색</Button>
            </div>
        </div>

        <div>
            <div style={{ fontWeight: 700, fontSize: '14px', marginBottom: '10px' }}>
                검색 결과 ({fillteredDataList.length ?? 0})
            </div>
            <Table dataSource={fillteredDataList} rowKey={'id'} columns={cancelManageColumns} loading={isFetching} />
        </div>
    </>
}

export default CancelManage;